(function() {
  'use strict';

  function initLocalizationSwitchers() {
    document.querySelectorAll('[data-localization-switcher]').forEach(function(switcher) {
      if (switcher.hasAttribute('data-localization-ready')) return;
      switcher.setAttribute('data-localization-ready', 'true');

      var form = switcher.querySelector('.localization-switcher__form');
      var countryInput = switcher.querySelector('[data-localization-country-input]');
      var countryOptions = Array.prototype.slice.call(
        switcher.querySelectorAll('[data-localization-country-option]')
      );
      var searchInput = switcher.querySelector('[data-localization-search]');

      if (!form) return;

      countryOptions.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var code = btn.getAttribute('data-country-code');
          if (!code || !countryInput) return;

          countryInput.value = code;

          switcher.querySelectorAll('.localization-switcher__country-item').forEach(function(item) {
            item.classList.remove('is-active');
            item.removeAttribute('aria-selected');
          });
          var li = btn.closest('.localization-switcher__country-item');
          if (li) {
            li.classList.add('is-active');
            li.setAttribute('aria-selected', 'true');
          }

          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        });
      });

      if (searchInput && countryOptions.length) {
        searchInput.addEventListener('input', function() {
          var query = (searchInput.value || '').trim().toLowerCase();
          countryOptions.forEach(function(btn) {
            var name = (btn.getAttribute('data-country-name') || '').toLowerCase();
            var code = (btn.getAttribute('data-country-code') || '').toLowerCase();
            var currency = (btn.getAttribute('data-country-currency') || '').toLowerCase();
            var match = !query || name.indexOf(query) !== -1 || code.indexOf(query) !== -1 || currency.indexOf(query) !== -1;
            var item = btn.closest('.localization-switcher__country-item');
            if (item) item.hidden = !match;
          });
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLocalizationSwitchers);
  } else {
    initLocalizationSwitchers();
  }

  document.addEventListener('shopify:section:load', initLocalizationSwitchers);
})();
